import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../OptionsColor";
export var Background = /*#__PURE__*/function () {
  function Background() {
    _classCallCheck(this, Background);
    this.color = new OptionsColor();
    this.color.value = "";
    this.image = "";
    this.position = "";
    this.repeat = "";
    this.size = "";
    this.opacity = 1;
  }
  _createClass(Background, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.color !== undefined) {
        this.color = OptionsColor.create(this.color, data.color);
      }
      if (data.image !== undefined) {
        this.image = data.image;
      }
      if (data.position !== undefined) {
        this.position = data.position;
      }
      if (data.repeat !== undefined) {
        this.repeat = data.repeat;
      }
      if (data.size !== undefined) {
        this.size = data.size;
      }
      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
    }
  }]);
  return Background;
}();